/**
 * Set the browser tab favicon (and apple-touch-icon) from the company logo URL.
 */
export function setCompanyFavicon(logoUrl) {
  if (typeof document === 'undefined') return;

  const href = (logoUrl || '').trim();
  if (!href || href.startsWith('data:')) {
    // Skip base64 — too large for favicon and unreliable across browsers
    return;
  }

  const lower = href.toLowerCase();
  const type = lower.includes('.svg')
    ? 'image/svg+xml'
    : lower.includes('.jpg') || lower.includes('.jpeg')
      ? 'image/jpeg'
      : lower.includes('.webp')
        ? 'image/webp'
        : 'image/png';

  const apply = (rel) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', rel);
      document.head.appendChild(link);
    }
    link.setAttribute('type', type);
    // Cache-bust so logo updates show after settings change
    const sep = href.includes('?') ? '&' : '?';
    link.setAttribute('href', `${href}${sep}v=${Date.now()}`);
  };

  apply('icon');
  apply('shortcut icon');
  apply('apple-touch-icon');
}
